import AuthProvider from "../context/auth/Provider";
import usePageTitle from "../hooks/page/pageTitle";
import Providers from "./providers/Providers";

import Routes from "./router/Routes";

function App() {
  usePageTitle();

  return (
    <AuthProvider>
      <Providers>
        <Routes />
      </Providers>
    </AuthProvider>
  );
}

export default App;
